;(function(){
    //BTOCSITE-61154 타임딜 전용관 진입시 해시태그 scrollTop 위치잡기
    if( $('.tdp-wrap').length > 0){
        $(document).on('ready',function(){
            if(location.hash && sessionStorage.getItem("timedealPreHash") !== location.hash){
                sessionStorage.setItem("timedealPreHash",location.hash);
                $(window).scrollTop($(location.hash).offset().top-46);
            }
        });
        setTimeout(function(){
            $('.tdp-wrap').css('visibility','visible');
        });
    }

    function addModalDimCss() {
        setTimeout(function(){
            $('.ui_modal_dim').css({background:'#4c4c4c', opacity:'1'});
        });
    }

    var planEventId = $("#exhibitionDiv").data("plan-event-id");
    var planEventType = $("#exhibitionDiv").data("plan-event-type");
    var loginUrl = $("#exhibitionDiv").data("login-url");
    var dimHtml = '<div style="background:#4c4c4c;position:fixed;width:100%;height:100%;top:0;left:0;z-index:9000"></div>';

    var param = {"planEventId" : planEventId, "planEventType" : planEventType}
    lgkorUI.requestAjaxData("/evt/ajax/exhibitions/loginInfo", param, function(result) {
        if (result.status == "success") {
            var partnerType = result.data[0].partnerType || "";
            var empYn = result.data[0].empYn || "";
            var isLogin = result.data[0].isLogin || "";
            var bsnsMbrStat = result.data[0].bsnsMbrStat || "";
            var isMatchingPartnerType = result.data[0].isMatchingPartnerType || "";
            var isMatchingPartnerCode = result.data[0].isMatchingPartnerCode || "";

            if ("Y" === isLogin) {
                $("input[name=partnerType]").val(partnerType);
                $("input[name=bsnsMbrStat]").val(bsnsMbrStat);
            }

            if ("b2b" === planEventType) {
                if ("ENT" === partnerType && "Y" === isLogin) {
                    $("div[name=b2bPriceBottom]").show();
                } else {
                    $("div[name=b2bPriceBottom]").remove();
                    $("div[name=b2bHiddenPriceBottom]").show();
                }
            }

            if ("employee" === planEventType) {
                if ("N" === isLogin) {
                    $('body').append(dimHtml);
                    $(".subRenewWrap").css('visibility','hidden');

                    lgkorUI.alert("", {title: "로그인을 해주세요.", ok: function(){
                            location.href = loginUrl;
                        }});
                    addModalDimCss();
                } else {
                    if ("N" === empYn) {
                        $('body').append(dimHtml);
                        $(".subRenewWrap").css('visibility','hidden');

                        lgkorUI.confirm('', {
                            title: '임직원 등록이 필요 합니다.<br>이동하시겠습니까?',
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok: function() {
                                location.href = "/employee/registration-info";
                            },
                            cancel: function() {
                                location.href = "/employee/registration-info";
                            }
                        });
                        addModalDimCss();
                    }
                }
            }

            if ("alliance" === planEventType || "affiliate" === planEventType) {
                if ("N" === isLogin) {
                    $('body').append(dimHtml);
                    var titleHead = planEventType === "alliance" ? "복지몰" : "계열사임직원몰";

                    lgkorUI.confirm('', {
                        title: titleHead+' 혜택을 받기 위해 <br> LGE.COM 로그인이 필요합니다.<br>이동하시겠습니까?',
                        okBtnName: '네',
                        cancelBtnName: '아니오',
                        ok: function() {
                            location.href = loginUrl;
                        },
                        cancel: function() {
                            location.href = "/benefits/exhibitions";
                        }
                    });
                    addModalDimCss();
                } else {
                    if (partnerType !== "AFC" && partnerType !== "AFF") {
                        $('body').append(dimHtml);

                        lgkorUI.confirm('', {
                            title: '임직원 등록이 필요합니다.<br>이동하시겠습니까?',
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok: function() {
                                location.href = "alliance" === planEventType ? "/employee-alliance/registration-info" : "/employee-affiliate/registration-info";
                            },
                            cancel: function() {
                                location.href = "/benefits/exhibitions";
                            }
                        });
                        addModalDimCss();
                    }
                    if ((partnerType === 'AFC' || partnerType === 'AFF') && (isMatchingPartnerType === 'N' || isMatchingPartnerCode === 'N')) {
                        $('body').append(dimHtml);
                        lgkorUI.alert("", {title: "페이지접근 권한이 없습니다.", ok: function(){
                                location.href = "/benefits/exhibitions";
                            }});
                        addModalDimCss();
                    }
                }
            }
        }
    }, "GET", "json");

    var productItemTemplate =
        '<li>'+
            '<div class="item evt-item">' +
                '<div class="product-image" aria-hidden="true">' +
                '<a href="{{modelUrlPath}}"><img src="{{mediumImageAddr}}" alt="{{imageAltText}}"></a>' +
            '</div>' +
            '<div class="product-contents">' +
                '{{#if siblings}}'+
                    '{{#each sibling in siblings}}'+
                    '<div class="product-option ui_smooth_scrolltab {{sibling.siblingType}}">' +
                        '<div class="ui_smooth_tab">' +
                            '<ul class="option-list" role="radiogroup">' +
                                '{{#each item in sibling.siblingModels}}'+
                                    '<li>'+
                                        '<div role="radio" class="{{#if sibling.siblingType=="color"}}chk-wrap-colorchip {{item.siblingCode}}{{#else}}rdo-wrap{{/if}}" aria-describedby="{{modelId}}" title="{{item.siblingValue}}">'+
                                            '<input type="radio" data-category-id="{{categoryId}}" id="product-{{sibling.siblingType}}-{{item.modelName}}" name="nm_{{sibling.siblingType}}_{{modelId}}" value="{{item.modelId}}" {{#if modelId==item.modelId}}checked{{/if}}>'+
                                            '{{#if sibling.siblingType=="color"}}'+
                                                '<label for="product-{{sibling.siblingType}}-{{item.modelName}}"><span class="blind">{{item.siblingValue}}</span></label>'+
                                            '{{#else}}'+
                                                '<label for="product-{{sibling.siblingType}}-{{item.modelName}}">{{item.siblingValue}}</label>'+
                                            '{{/if}}'+
                                        '</div>'+
                                    '</li>'+
                                '{{/each}}' +
                            '</ul>' +
                        '</div>' +
                        '<div class="scroll-controls ui_smooth_controls">' +
                            '<button type="button" class="btn-arrow prev ui_smooth_prev"><span class="blind">이전</span></button>' +
                            '<button type="button" class="btn-arrow next ui_smooth_next"><span class="blind">다음</span></button>' +
                        '</div>' +
                    '</div>' +
                    '{{/each}}'+
                '{{/if}}'+
                '<div class="flag-wrap bar-type">' +
                    '{{#if newProductBadgeFlag}}<span class="flag">{{newProductBadgeName}}</span>{{/if}}' +
                    '{{#if bestBadgeFlag}}<span class="flag">{{bestBadgeName}}</span>{{/if}}' +
                '</div>' +
                '<div class="product-info">' +
                    '<div class="product-name">' +
                        '<a href="{{modelUrlPath}}">{{#raw modelDisplayName}}</a>' +
                    '</div>' +
                    '<div class="sku">{{#if salesModelCode}}{{salesModelCode}}{{/if}}</div>' +
                        '<div class="review-info">' +
                            '<a href="#">' +
                                '{{#if (reviewsCount != "0")}}' +
                                '<div class="star is-review"><span class="blind">리뷰있음</span></div>' +
                                '<div class="average-rating"><span class="blind">평점</span>{{reviewsScore}}</div>' +
                                    '{{#if (reviewsCount > 9999)}}' +
                                        '<div class="review-count"><span class="blind">리뷰 수</span>(9,999+)</div>' +
                                    '{{/if}}' +
                                    '{{#if (reviewsCount <= 9999)}}' +
                                        '<div class="review-count"><span class="blind">리뷰 수</span>({{reviewsCount}})</div>' +
                                    '{{/if}}' +
                                '{{/if}}' +
                            '</a>' +
                        '</div>' +
                        '<ul class="spec-info">' +
                            '{{#if showBulletFeatures}}' +
                                '{{#each item in showBulletFeatures}}' +
                                    '<li>{{#raw item.specText}}</li>' +
                                '{{/each}}' +
                            '{{/if}}' +
                            '{{#if cTypeCount > 0}}<li>{{lastBulletName}}</li>{{/if}}'+
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<div class="product-bottom">' +
                    '<div class="flag-wrap bar-type">' +
                        '{{#if cashbackBadgeFlag}}<span class="flag">{{cashbackBadgeName}}</span>{{/if}}' +
                    '</div>' +
                    '<div class="price-area">' +
                        '{{#if obsOriginalPrice}}<div class="original">' +
                            '<em class="blind">판매가격</em>' +
                            '<span class="price">{{obsOriginalPrice}}<em>원</em></span>' +
                        '</div>{{/if}}' +
                        '{{#if obsSellingPrice}}<div class="total">' +
                            '<em class="blind">총 판매가격</em>' +
                            '<span class="price">{{obsSellingPrice}}<em>원</em></span>' +
                        '</div>{{/if}}' +
                        '{{#if discount}}'+
                        '<div class="discount">'+
                            '<em class="blind">할인율</em>'+
                            '<span class="percentage">{{discount}}%</span>'+
                        '</div>'+
                        '{{/if}}'+
                    '</div>' +
                    '<div class="btn-area-wrap">' +
                        '<div class="cart">' +
                            '<a href="#n" class="btn-cart{{#if obsBtnRule != "enable"}} disabled{{/if}}" data-id="{{modelId}}" data-model-name="{{sku}}" data-rtSeq="{{rtModelSeq}}" data-type-flag="{{bizType}}" {{#if obsBtnRule != "enable"}}disable{{/if}}><span class="blind">장바구니 담기</span></a>' +
                        '</div>' +
                        '<div class="btn-area">' +
                            '<a href="{{modelUrlPath}}" class="btn border size-m" data-id="{{modelId}}">자세히 보기</a>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>'+
        '</li>';
        //BTOCSITE-54267 : 3차 기획전 제작 모듈화(컴퍼넌트화) 개발 : 소모품 제품 유닛 UI 변경
        var productItemTemplateAcc =
        '<li>'+
            '<div class="item {{#if modelStatusCode == "SOLD_OUT"}}soldout{{/if}}">' +
                '<div class="flag-wrap">' +
                    '{{#if modelStatusCode == "READY_FOR_SALE"}}'+
                        '<span class="flag red">판매예정</span>'+
                    '{{/if}}'+
                    '{{# for (var i = 0; i < boldBadgeList.length; i++) { #}}' +
                        '<span class="flag" data-badge-id="{{boldBadgeList[i].badgeId}}">{{boldBadgeList[i].badgeName}}</span>' +
                    '{{# } #}}' +
                '</div>' +
                '<div class="product-contents">' +
                    '<div class="product-info">' +
                        '<div class="product-name">' +
                            '<a href="{{modelUrlPath}}">{{#raw modelDisplayName}}</a>' +
                        '</div>' +
                        '<div class="sku">{{sku}}</div>' +
                    '</div>' +
                    '<div class="product-image" aria-hidden="true">' +
                        '<a href="{{modelUrlPath}}"><img src="{{mediumImageAddr}}" alt="{{modelDisplayName}}"></a>' +
                    '</div>' +
                '</div>' +
                '<div class="product-bottom">' +
                    '{{#if obsOriginalPrice != "0"}}'+
                        '<div class="price-area">' +
                            '<div class="total">' +
                                '<em class="blind">할인 후 판매가</em>' +
                                '<span class="price"><strong>{{totalPrice}}</strong>원</span>' +
                            '</div>' +
                        '</div>' +
                    '{{/if}}' +
                '</div>' +
                '{{#if compatibleModel.length}}'+
                    '<div class="item_spec">' +
                        '<div class="spec_modelarea">' +
                            '<a href="#popupSharedModel" class="model_btnall" data-control="modal" data-model-id="{{modelId}}">사용가능모델 : 총 {{compatibleModelSummary.total}}개</a>' +
                        '</div>' +
                    '</div>' +
                '{{/if}}' +
                '{{#if modelStatusCode == "SOLD_OUT"}}' +
                    '<div class="btm-infobox">'+
                        '<div class="flag-wrap bg-type">'+
                            '<span class="flag soldout">일시품절</span>'+
                        '</div>'+
                    '</div>'+
                '{{/if}}'+
                '<div class="btn-area-wrap">' +
                    '<div class="wishlist">' +
                        '<span class="chk-wish-wrap">' +
                            '<input type="checkbox" {{#if wishListFlag == "true"}}checked{{/if}} id="wish-{{sku}}" name="wish-{{sku}}" data-id="{{modelId}}" data-wish-model-name="{{sku}}" data-model-name="{{sku}}" data-wish-list-id="{{wishItemId}}" data-contents="{{modelDisplayName}}" data-wish-item-id="{{wishItemId}}">' +
                            '<label for="wish-{{sku}}"><span>위시리스트</span></label>' +
                        '</span>' +
                    '</div>' +
                '</div>' +
            '</div>'+
        '</li>';
    var modelListPopupTemplate =
        '<header class="pop-header">'+
            '<h1 class="tit"><span>사용 가능한 모델</span></h1>'+
        '</header>'+
        '<section class="pop-conts">'+
            '<div class="model-information shared-model">'+
                '<div class="tit-wrap">'+
                    '<div class="input-wrap search">'+
                        '<input type="text" name="keyword" id="keyword" class="ui_input_clearbutton" placeholder="모델명을 입력해주세요." title="모델명을 입력해주세요." data-clear-button="button.btn-delete" value="">'+
                        '<button type="button" class="btn-delete"><span class="blind">검색어 삭제</span></button>'+
                        '<button type="button" class="btn-search"><span class="blind">검색</span></button>'+
                    '</div>'+
                '</div>'+
                '<div class="count">'+
                    '총 <em>{{modelCnt}}</em>개'+
                '</div>'+
                '<div class="model-information-wrap">'+
                    '<div class="no-data" {{#if modelCnt !== "0"}} style="display:none"{{/if}}>입력하신 모델과 일치하는 모델을 찾지 못했습니다.</div>'+
                    '<ul class="model-information-list" {{#if modelCnt == "0"}} style="display:none"{{/if}}>'+
                        '{{#each item in modelList}}' +
                        '<li>{{item}}</li>'+
                        '{{/each}}' +
                    '</ul>'+
                '</div>'+
            '</div>'+
        '</section>'+
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';

    //BTOCSITE-54267 : 3차 기획전 제작 모듈화(컴퍼넌트화) 개발 : 쿠폰 상세 팝업
    var cpnInfoPopupTemplate =
        '<header class="pop-header">'+
            '<h1 class="tit"><span>쿠폰 상세정보</span></h1>'+
        '</header>'+
        '<section class="pop-conts common-pop cp-pop">'+
            '<div class="cp-cont-info">'+
                '<em class="tit">{{_cpDiscVal}}<i class="unit">{{_cpDiscUnit}}</i></em>'+
                '<p class="desc">{{cpDispName}}</p>'+
                '<div class="graybox">'+
                    '<strong class="sub-tit">{{#if isDownload==="N"}}발급기간{{#else}}유효기간{{/if}}</strong>'+
                    '<div class="sub-cont">{{_cpPublStDate}} 부터 <br>{{_cpPublEdDate}} 까지</div>'+
                    '{{#if cpDiscMinPrice !== "" }}'+
                    '<strong class="sub-tit">할인조건</strong>'+
                    '<div class="sub-cont">{{cpDiscMinPrice}}</div>'+
                    '{{/if}}'+
                    '{{#if cpPartnerType === "ENT"}}'+
                    '<strong class="sub-tit">적용모델</strong>'+
                    '<div class="sub-cont">사업자몰 전체모델<br>일부모델은 적용대상에서 제외될 수 있습니다.</div>'+
                    '{{/if}}'+
                '</div>'+
            '</div>'+
        '</section>'+
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';

    //BTOCSITE-65935 : 내일 배송 팝업 템플릿 추가
    var deliveryPopupTemplate =
        '<header class="pop-header">'+
            '<h1 class="tit"><span>내일배송</span></h1>'+
        '</header>'+
        '<section class="pop-body">'+
            '<div class="info-text">선택한 제품의 배송방법과 일정을 확인하세요</div>'+
            '<div class="delivery-area">'+
            '{{#if tomorrowDelivList}}' +
                '{{#each deliv in tomorrowDelivList}}' +
                    '<div class="delivery-info">'+
                        '<span class="title">{{deliv.delivTitle}}</span>'+
                        '<span class="text">{{deliv.nextdayFullText}}</span>'+
                    '</div>'+
                '{{/each}}' +
            '{{/if}}' +
            '</div>'+
            '{{#if listCnt > 1}}'+
            '<div class="desc-text">※ 배송방법은 주문/결제화면에서 선택할 수 있습니다.</div>'+
            '{{/if}}'+
            '<div class="notice-area">'+
                '<p class="notice-title">유의사항</p>'+
                '{{#if tomorrowDelivList}}' +
                    '{{#each deliv in tomorrowDelivList}}' +
                        '<div class="notice-list">'+
                            '<strong class="title">{{deliv.delivTitle}}</strong>'+
                            '{{#if deliv.deliveryType === "H"}}'+
                                '<ul>'+
                                    '{{#if deliv.deliveryTitleCd === "01"}}'+
                                        '<li>전문 설치기사가 직접 방문하여 제품 설치 및 사용방법을 안내해드리는 One-Stop 배송 서비스 입니다.</li>'+
                                        '<li>제품 배송 전에 등록하신 번호로 알림톡이 발송되며, 배송 당일에는 설치 기사가 연락 드립니다.</li>'+
                                        '<li>내일배송 가능 상품의 경우 오후 3시 이전 결제 시 내일 배송이 가능합니다.</li>'+
                                    '{{#else}}'+
                                        '<li>전문 배송기사가 직접 안전하게 배송해 드립니다.</li>'+
                                        '<li>내일배송 가능 제품의 경우 오후 3시 이전 결제 시 내일배송이 가능합니다.</li>'+
                                    '{{/if}}'+
                                    '{{#if listCnt < 2}}'+
                                        '<li>제주도/도서산간 지역은 배송 일정이 변경될 수 있으며, 일부 지역은 실제 배송이 되지 않아 주문 취소가 될 수 있습니다.</li>'+
                                        '<li>일요일/공휴일/물류 휴무일에는 배송이 되지 않습니다.</li>'+
                                    '{{/if}}'+
                                '</ul>'+
                            '{{/if}}'+
                            '{{#if deliv.deliveryType === "P"}}'+
                                '<ul>'+
                                    '<li>택배사를 통해 배송해 드립니다. (CJ대한통운)</li>'+
                                    '<li>택배배송 가능 제품의 경우 오후 11시 이전 결제 시 내일 도착이 가능합니다.</li>'+
                                    '{{#if listCnt < 2}}'+
                                    '<li>제주도/도서산간 지역은 배송 일정이 변경될 수 있으며, 일부 지역은 실제 배송이 되지 않아 주문 취소가 될 수 있습니다.</li>'+
                                    '<li>일요일/공휴일/물류 휴무일에는 배송이 되지 않습니다.</li>'+
                                    '{{/if}}'+
                                '</ul>'+
                            '{{/if}}'+
                        '</div>'+
                    '{{/each}}' +
                '{{/if}}'+
                '{{#if listCnt > 1}}'+
                '<div class="notice-list">'+
                    '<strong class="title">공통사항</strong>'+
                        '<ul>'+
                            '<li>제주도/도서산간 지역은 배송 일정이 변경될 수 있으며, 일부 지역은 실제 배송이 되지 않아 주문 취소가 될 수 있습니다.</li>'+
                            '<li>일요일/공휴일/물류 휴무일에는 배송이 되지 않습니다.</li>'+
                        '</ul>'+
                '</div>'+
                '{{/if}}'+
            '</div>'+
        '</section>'+
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';

    var $contents;
    var $productList; // BTOCSITE-7637
    var categoryProductListSelector = $("#tab09 .product-items .item");

    function init(){
        setting();
        bindEvents();
        insertViewHistory();
        checkCouponDownload();

        var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
        if("Y" === isLogin) {
            checkRecentlyViewdModel();
        }

        var ajaxUrl = $contents.attr('data-wish-url');// BTOCSITE-7637
        lgkorUI.checkWishItem(ajaxUrl); // BTOCSITE-7637

        //BTOCSITE-54267 : 3차 기획전 제작 모듈화(컴퍼넌트화) 개발 : slide 관련 스크립트 추가
        var moduleYn = $('.today-wrap .today-new .recomm-exhibitions-inner').attr('data-module-yn');

        if(moduleYn === "Y"){
            loadSlide();
        }

    }

    function setting(){
        $contents = $('.contents.event.exhibition');
        //리스트
        $productList = $('.contents.exhibition ul.product-items');// BTOCSITE-7637 //BTOCSITE-13718 기획전/이벤트 페이지 내 소모품 PLP 추가 기능 생성 요청 건
        
        // BTOCSITE-24121 임직원 기획전 로그아웃 URL 변경 - 로그아웃시 메인으로 이동
        var planEventType = $contents.data("plan-event-type");
        if (planEventType == "employee") {
            var logoutUrl = "/sso/member/logout?state=" + location.origin;
            $(".after-login .mypage-layer .mypage-layer-inner").find("a").attr("href", logoutUrl);
            $(".nav-logout").find("a").attr("href", logoutUrl);
        }

        // BTOCSITE-48265 공유하기 url b2bYn 파라미터 설정 안되는 이유로 재설정
        $('meta[property="og:url"]').attr('content', location.href);
    }

    function bindEvents(){ 

        // BTOCSITE-7637
        //찜하기
        $productList.on('change', 'li div.btn-area-wrap div.wishlist input', function(e){
            var login = $contents.data('loginUrl');
            var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
            //BTOCSITE-38964
            if(isLogin == "N"){
                /* BTOCSITE-17584 찜하기KT 전환으로 인한 기획전/이벤트 영향범위 수정 */
                var obj = {
                    title:'선택하신 제품을 위시리스트에 담기 위해서는 <br>LG전자 통합 사이트의 로그인이 필요합니다.', 
                    cancelBtnName:'취소', 
                    okBtnName:'확인', 
                    ok: function (){
                        location.href = login;
                    }
                };
                //BTOCSITE-77414 > WA 전문가점검 > 6. 위시리스트 -> 로그인 -> 초점 이전
                lgkorUI.confirm(null, obj, $(this));
                $(this).prop('checked', false);
                return;

            } else{
                var $this = $(this);
                var _id = $this.attr('data-id');
                var sku = $this.attr('data-model-name');
                var wishListId = $this.data("wishListId"); 
                var wishItemId = $this.data("wishItemId");
                var wish = $this.is(':checked');
                var param = {
                    "id":_id,
                    "sku":sku,
                    "wishListId": wishListId,
                    "wishItemId": wishItemId
                }

                if(wish){
                    param.type = "add";
                } else{
                    param.type = "remove";
                }

                var ajaxUrl = $contents.attr('data-wish-url');
                
                var success = function(data) {
                    $this.data("wishItemId",data.wishItemId);
                    $this.prop("checked",wish);
                };
                var fail = function(data) {
                    $this.prop("checked",!wish);
                };

                lgkorUI.requestWish(
                    param,
                    wish,
                    success,
                    fail,
                    ajaxUrl,
                    this
                );
            }
        });
        // BTOCSITE-7637

        // 장바구니
        $contents.on('click', '.btn-area-wrap .cart .btn-cart', function(e){
            e.preventDefault();

            var typeflag = $(this).attr('data-type-flag');
            var sendflag = (typeflag == "PRODUCT" || typeflag == "DISPOSABLE") ? "P" : "C";
            var url = $(this).attr('data-url');
            var planEventType = $contents.data("plan-event-type");

            if(typeflag == 'CARESHIP'){
            	$('.lay-wrap .btn-wrap.laypop .btn-confirm').attr('onClick', 'location.href=' + "'" + url + "'");
            }
            else if(!$(this).hasClass('disabled')){
                var $this = $(this);
                var param = {
                    "id":$this.attr('data-id'),
                    "sku":$this.attr('data-model-name'),
                    "rtSeq":$this.attr('data-rtSeq'),
                    "typeFlag": sendflag,
                    "b2cYn": planEventType == 'b2b' ? 'N' : 'Y'
                }
                // BTOCSITE-49721 UP가전 2.0+가전구독 통합 장바구니 기능 구현
                var modelList = [];
                var modelMap = {
                		"modelId": $this.attr('data-id'),
                      	"sku": $this.attr('data-model-name'),
                      	"rtModelSeq": $this.attr('data-rtSeq'),
                      	"bizType": typeflag
                };
                modelList.push(modelMap);
                param.modelList = JSON.stringify(modelList);

                var ajaxUrl = $contents.attr('data-cart-url');
                lgkorUI.requestCart(ajaxUrl, param, true);
            }
        }).on('change', '.product-option input[type=radio]', function(e){
            requestSibling(this);
        })

        //BTOCSITE-45005 기획전 모듈화 추천 제품 영역 장바구니 담기
        $contents.on('click', '.product-btm-lower .btn-area-wrap .btn-area .btn', function(e){
                    e.preventDefault();

                    var typeflag = $(this).attr('data-type-flag');
                    var sendflag = (typeflag == "PRODUCT" || typeflag == "DISPOSABLE") ? "P" : "C";
                    var url = $(this).attr('data-url');
                    var planEventType = $contents.data("plan-event-type");

                    if(typeflag == 'CARESHIP'){
                        $('.lay-wrap .btn-wrap.laypop .btn-confirm').attr('onClick', 'location.href=' + "'" + url + "'");
                    }
                    else if(!$(this).hasClass('disabled')){
                        var $this = $(this);
                        var param = {
                            "id":$this.attr('data-id'),
                            "sku":$this.attr('data-model-name'),
                            "rtSeq":$this.attr('data-rtSeq'),
                            "typeFlag": sendflag,
                            "b2cYn": planEventType == 'b2b' ? 'N' : 'Y'
                        }
                        // BTOCSITE-49721 UP가전 2.0+가전구독 통합 장바구니 기능 구현
                        var modelList = [];
                        var modelMap = {
                        		"modelId": $this.attr('data-id'),
                              	"sku": $this.attr('data-model-name'),
                              	"rtModelSeq": $this.attr('data-rtSeq'),
                              	"bizType": typeflag
                        };
                        modelList.push(modelMap);
                        param.modelList = JSON.stringify(modelList);

                        var ajaxUrl = $contents.attr('data-cart-url');
                        lgkorUI.requestCart(ajaxUrl, param, true);
                    }
        }).on('change', '.product-option input[type=radio]', function(e){
            requestSibling(this);
        })


        /* BTOCSITE-13718 기획전/이벤트 페이지 내 소모품 PLP 추가 기능 생성 요청 건 */
        //소모품 탭
        $contents.on('click', '.ev-accessories-tab .tabs a', function(e){
            e.preventDefault();
            var prdGroupId = $(this).attr('data-prd-group-id');
            getProductList(e.target.hash,prdGroupId);
        })

        //소모품 > 사용 가능한 모델 팝업 호출
        $contents.on('click', '.spec_modelarea a', function(e){
            e.preventDefault();

            var modelId = $(this).attr('data-model-id')
            clickViewModel(modelId);
        })

        //소모품 > 사용 가능한 모델 팝업 : 모델명 검색
        $(document).on('input', '.shared-model .ui_input_clearbutton', function(e){
            e.preventDefault();

            inputPopShareModel(e);
        })
        /* //BTOCSITE-13718 기획전/이벤트 페이지 내 소모품 PLP 추가 기능 생성 요청 건 */

        //BTOCSITE-54267 : 3차 기획전 제작 모듈화(컴퍼넌트화) 개발 START
        //쿠폰혜택 > 개별 쿠폰 다운로드
        $contents.on('click', '#coupon .coupon-box .cp-btn button', function(e){
            e.preventDefault();
            var planEventId = $contents.data("plan-event-id");
            var couponId = $(e.currentTarget).closest("li").attr("data-coupon-id");
            var encCouponId = $(e.currentTarget).closest("li").attr("data-enc-coupon-id");
            var unifyId = vcui.Cookie.get("UNIFY_ID");

            var loginUrl = $contents.data('loginUrl');
            var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";

            if(isLogin === "N"){
                var obj = {
                    title:'로그인 후 받으실 수 있습니다.',
                    ok: function (){
                        location.href = loginUrl;
                    }
                };
                lgkorUI.alert(null, obj);
                return;
            } else {
                var ajaxUrl = $contents.attr('data-coupon-down-ajax');
                var param = {};
                param.couponId = couponId;
                param.userId = unifyId;
                param.planEventId = planEventId;
                //param.userId = "01090458474";
                param.encCouponId = encCouponId;

                var alertObj = "";

                lgkorUI.requestAjaxDataPost(
                    ajaxUrl,
                    param,
                    function (result) {
                        lgkorUI.hideLoading();
                        if (result.code === "0000") {
                            //success
                            alertObj = $.extend(alertObj, { title: "쿠폰 다운로드가 완료되었습니다." });
                            lgkorUI.alert(null, alertObj);

                            $(e.currentTarget).addClass("comp");
                            $(e.currentTarget).css('cursor', 'default');
                            $(e.currentTarget).css('pointer-events', 'none');
                            $(e.currentTarget).css('color', '#'+$(e.currentTarget).parent().attr("data-btn-color"));
                            $(e.currentTarget).text("");
                            $(e.currentTarget).html("<span>발급<br>완료</span>");
                            //BTOCSITE-72263 : 기획전 모듈화 쿠폰 디자인 수정 및 컬러 선택 추가 요청 : 발급 완료 bg rgb 설정 추가
                            $(e.currentTarget).parent().parent().attr('style', '--cop-color:#666');

                            var couponCnt = $("#coupon .evt-cont .coupon-list .coupon-box").size();
                            var downCnt = $("#coupon .evt-cont .coupon-list .cp-btn .comp").size();

                            var $allDownBtn = $("#coupon .noti-cont .btn-area button");

                            if(parseInt(couponCnt) === parseInt(downCnt)){
                                $allDownBtn.text("");
                                $allDownBtn.text("전체 쿠폰 다운로드 완료");
                                $allDownBtn.attr("disabled", true);
                            }

                        } else {
                            //fail
                            //console.log("MSG : " + result.data.jobDoErrMsg);
                            if(result.errorMsg != "" && result.errorMsg != null){
                                alertObj = $.extend(alertObj, { title: result.errorMsg });
                            }else{
                                alertObj = $.extend(alertObj, { title: "쿠폰 다운로드에 실패 하였습니다.<br/>잠시 후 재시도 해주세요." });
                            }
                            lgkorUI.alert(null, alertObj);
                        }
                    }.bind(this),
                    true,
                    true
                );
            }

        });

        //쿠폰혜택 > 쿠폰 전체 다운로드
        $contents.on('click', '#coupon .noti-cont .btn-area button', function(e){
            e.preventDefault();

            var obj;
            var couponIds = [];
            var encCouponIds = [];

            $("#coupon .evt-cont .coupon-list .coupon-box").each(function () {
                 if(!$(this).find(".cp-btn button").hasClass("comp")){
                    couponIds.push($(this).attr("data-coupon-id"));
                     encCouponIds.push($(this).attr("data-enc-coupon-id"));
                }
            });

            if (couponIds.length === 0) {
                obj = $.extend(obj, { title: "다운로드할 수 있는 쿠폰이 없습니다." });
                lgkorUI.alert(null, obj);
                return;
            }

            var loginUrl = $contents.data('loginUrl');
            var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
            var unifyId = vcui.Cookie.get("UNIFY_ID");
            var planEventId = $contents.data("plan-event-id");

            if(isLogin === "N"){
                var obj = {
                    title:'로그인 후 받으실 수 있습니다.',
                    ok: function (){
                        location.href = loginUrl;
                    }
                };
                lgkorUI.alert(null, obj);
                return;
            } else {
                var ajaxUrl = $contents.attr('data-coupon-alldown-ajax');
                var param = {};
                param.couponId = couponIds;
                param.encCouponId = encCouponIds;
                param.userId = unifyId;
                param.planEventId = planEventId;

                lgkorUI.requestAjaxDataPost(
                    ajaxUrl,
                    param,
                    function (result) {
                        lgkorUI.hideLoading();
                        if (result.code === "0000") {
                            //success
                            if(result.isALL != "Y"){
                                obj = $.extend(obj, { title: "다운로드 가능한 쿠폰이 모두 발급되었습니다.<br>마이페이지를 확인해주세요." });
                            }else{
                                obj = $.extend(obj, { title: "전체 쿠폰 다운로드 처리가 완료되었습니다." });
                            }
                            lgkorUI.alert(null, obj);

                            if(result.isALL == "N"){
                                $("#coupon .evt-cont .coupon-list .coupon-box").each(function () {
                                    for(var i in result.enableCoupon){
                                        if(result.enableCoupon[i] == $(this).attr("data-coupon-id")){
                                            $(this).find(".cp-btn button").addClass("comp")
                                            $(this).find(".cp-btn button").css('cursor', 'default');
                                            $(this).find(".cp-btn button").css('pointer-events', 'none');
                                            $(this).find(".cp-btn button").css('color', '#'+$(this).find(".cp-btn button").parent().attr("data-btn-color"));
                                            $(this).find(".cp-btn button").text("");
                                            $(this).find(".cp-btn button").html("<span>발급<br>완료</span>");
                                            $(this).find(".cp-btn button").parent().parent().attr('style', '--cop-color:#666');
                                        }
                                    }
                                });
                            }else{
                                $("#coupon .evt-cont .coupon-list .cp-btn button").each(function () {
                                    $(this).addClass("comp");
                                    $(this).css('cursor', 'default');
                                    $(this).css('pointer-events', 'none');
                                    $(this).css('color', '#'+$(this).parent().attr("data-btn-color"));
                                    $(this).text("");
                                    $(this).html("<span>발급<br>완료</span>");
                                    //BTOCSITE-72263 : 기획전 모듈화 쿠폰 디자인 수정 및 컬러 선택 추가 요청 : 발급 완료 bg rgb 설정 추가
                                    $(this).parent().parent().attr('style', '--cop-color:#666');

                                    $(e.currentTarget).text("");
                                    $(e.currentTarget).text("전체 쿠폰 다운로드 완료");
                                    $(e.currentTarget).attr("disabled", true);
                                });
                            }

                        } else {
                            //fail
                            //console.log("MSG : " + result.data.jobDoErrMsg);
                            if(result.errorMsg != "" && result.errorMsg != null){
                                obj = $.extend(obj, { title: result.errorMsg });
                            }else{
                                obj = $.extend(obj, { title: "쿠폰 다운로드에 실패 하였습니다.<br/>잠시 후 재시도 해주세요." });
                            }
                            lgkorUI.alert(null, obj);
                        }
                    }.bind(this),
                    true,
                    true
                );
            }
        });

        //BTOCSITE-54267 : 3차 기획전 제작 모듈화(컴퍼넌트화) 개발 END
    }

    function requestSibling(rdo){
        var modelId = $(rdo).val();
        var changeItem = $(rdo).closest('.evt-item').parent();
        var bizType = changeItem.find('.product-bottom .btn-area-wrap .cart a').attr('data-type-flag');
        var ajaxurl = $contents.attr('data-sibling-url');
        var sendata = {
            "modelId": modelId,
            "bizType": bizType,
            "pageType": "plp",
            "callType": "productSummary"
        }
        
        lgkorUI.requestAjaxDataPost(ajaxurl, sendata, function(result){
            var arr = (result.data && result.data instanceof Array) ? result.data : [];

            if(arr.length){
                var item = arr[0];
                var listItem = makeListItem(item);
                changeItem.before(listItem);
                changeItem.remove();

                $contents.find('.ui_smooth_scrolltab').vcSmoothScrollTab();
            };
        }, true);
    }

    function makeListItem(item){

        for(var str in item.siblings){
            var siblingType = item.siblings[str].siblingType ? item.siblings[str].siblingType.toLowerCase() : '';
            item.siblings[str].siblingType = (siblingType == "color") ? "color" : "text";
        }

        var sliderImages = [];
        if(item.rollingImages && item.rollingImages.length){
            item.rollingImages.forEach(function(obj, idx) {
            if(obj && obj.smallImageAddr) {
                sliderImages.push(obj.smallImageAddr);
                }
            });
        } else {
            sliderImages.push(item.smallImageAddr);
        }
        item.sliderImages = sliderImages[0];
        
        item.obsOriginalPrice = (item.obsOriginalPrice != null) ? vcui.number.addComma(item.obsOriginalPrice) : null;
        item.obsTotalDiscountPrice = (item.obsTotalDiscountPrice != null) ? vcui.number.addComma(item.obsTotalDiscountPrice) : null;
        item.reviewsCount = (item.reviewsCount != null) ? vcui.number.addComma(item.reviewsCount) : "0";

        //flag
        item.newProductBadgeFlag = lgkorUI.stringToBool(item.newProductBadgeFlag);
        item.bestBadgeFlag = lgkorUI.stringToBool(item.bestBadgeFlag);
        item.cashbackBadgeFlag = lgkorUI.stringToBool(item.cashbackBadgeFlag);

        if(!item.newProductBadgeName) item.newProductBadgeName = "신제품"
        if(!item.bestBadgeName) item.bestBadgeName = "베스트";
        if(!item.cashbackBadgeName) item.cashbackBadgeName = "캐시백"
        if(!item.lastBulletName) item.lastBulletName = "케어십 가능";
        
        //장바구니
        item.wishListFlag = lgkorUI.stringToBool(item.wishListFlag);
        //찜하기
        item.cartListFlag = lgkorUI.stringToBool(item.cartListFlag);
        if(!item.wishListId) item.wishListId = "";
        if(!item.wishItemId) item.wishItemId = "";

        if(!item.rtModelSeq) item.rtModelSeq = "";

        var bulletLength = item.bulletFeatures.length;
        var showLength = bulletLength;
        if(bulletLength > 4){
            showLength = item.cTypeCount > 0 ? 4 : bulletLength;
        }
        item.showBulletFeatures = [];
        for(var i=0;i<showLength;i++){
            item.showBulletFeatures.push(item.bulletFeatures[i]);
        }

        if(!item.obsBtnRule) item.obsBtnRule = "";

        if(!item.sku) item.sku = item.modelName;

        if(!item.discount) item.discount = "";

        if(!item.obsSellingPrice) item.obsSellingPrice = "";

        //console.log("### item.siblingType ###", item.siblingType)

        return vcui.template(productItemTemplate, item);
    }

    /* BTOCSITE-13718 기획전/이벤트 페이지 내 소모품 PLP 추가 기능 생성 요청 건 */
    //소모품 리스트 호출
    function getProductList(value, prdGroupId) {
        var planEventId = $contents.data("plan-event-id");
        var superCategoryId = value.substring(1);
        var ajaxUrl = $contents.attr("data-disposable-product-url");
        var planEventPrdGroupUseFlag = $contents.data("plan-event-prd-group-use-flag"); // BTOCSITE-32123  기획전 제품 구분자 구조 개선 요청 
        var param = {};
        param.planEventId = planEventId;
        param.superCategoryId = superCategoryId;
        param.planEventPrdGroupUseFlag = planEventPrdGroupUseFlag;
        param.prdGroupId=prdGroupId; 

        lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
            if (result.status == "success") {
                var data = result.data;
                var arr = data instanceof Array ? data : [];
                var productItems;
                // BTOCSITE-32123  기획전 제품 구분자 구조 개선 요청 
                if(planEventPrdGroupUseFlag == 'Y'){
                    productItems = $(".tab-contents#accessories"+prdGroupId+" .product-items");
                }else{
                    productItems = $(".tab-contents#accessories .product-items");    
                }
                productItems.append().html('');

                arr.forEach(function (item, index) {
                    obsOriginalPrice = item.obsOriginalPrice;
                    cartFlag = true;
                    compatibleModel = [];

                    if(item.modelStatusCode != 'ACTIVE' || obsOriginalPrice == 0){
                        cartFlag = false;
                    }

                    //spec model
                    if(item.compatibleModelSummary.model){
                        compatibleModel = item.compatibleModelSummary.model.split(",");
                    }
                    item.compatibleModel = compatibleModel;                                      

                    productItems.append(vcui.template(productItemTemplateAcc, item));
                });
            }
        });
    }

    //소모품 > 사용 가능한 모델 팝업
    function clickViewModel(modelId) {
        var ajaxUrl = $contents.attr("data-compatible-product-url");
        var param = {};
        param.modelId = modelId;

        $("#popupSharedModel").attr("data-model-id", param.modelId);

        lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                if (result.status == "success") {
                    var compatibleModelList = result.data[0].compatibleModels;
                    var data = {};
                    data.modelList = compatibleModelList;
                    data.modelCnt = compatibleModelList.length;

                    $("#popupSharedModel").html(vcui.template(modelListPopupTemplate, data));
                }
            }.bind(this), true, true
        );
    }

    //소모품 > 사용 가능한 모델 팝업 : 모델명 검색
    function inputPopShareModel(e){
        var keyword = $(e.currentTarget).val().toUpperCase().trim();

        var regex = /[^a-zA-Z0-9.\-]/g;

        if (regex.test(keyword)) {
            $(e.currentTarget).val(keyword.replace(regex, ""));
            return;
        }

        var $list = $(e.currentTarget).parents(".model-information").find(".model-information-list");
        var $listItem = $list.find("li");
        var $nodata = $("#popupSharedModel .no-data");
        var $count = $(e.currentTarget).parents(".model-information").find(".count em");

        $listItem.hide();
        $count.html($list.find("li:contains('" + keyword + "')").length);
        $list.find("li:contains('" + keyword + "')").show();

        if (keyword == "") {
            $list.show();
            $nodata.hide();
        } else {
            if (!$list.find("li:contains('" + keyword + "')").length) {
                $list.hide();
                $nodata.show();
            } else {
                $list.show();
                $nodata.hide();
            }
        }
    }
    /* //BTOCSITE-13718 기획전/이벤트 페이지 내 소모품 PLP 추가 기능 생성 요청 건 */

    // BTOCSITE-48333 개인화 추천을 위한 이력 저장
    function insertViewHistory() {
        var planEventType = $contents.data("plan-event-type");
        var targetId = $contents.data("plan-event-id");
        var planEventEndFlag = $contents.data("plan-event-end-flag");
        if (!vcui.isEmpty(planEventType) && !vcui.isEmpty(targetId) && 'Y' != planEventEndFlag) {
            if (planEventType != "alliance" && planEventType != "affiliate" && planEventType != "employee" && planEventType != "time_deal") {
                var ajaxUrl = "/evt/event/insertEventHistoryView.lgajax";
                lgkorUI.requestAjaxDataPost(ajaxUrl, {'targetId' :  targetId}, function(result) {});
            }    
        }
    }

    //BTOCSITE-54267 : 3차 기획전 제작 모듈화(컴퍼넌트화) 개발 : slide 관련 스크립트 추가
    function loadSlide(){
        var isSetCarousel_module = false;
        $(window).on('resize', function(e){
            var $slide = $('.today-wrap .today-new .recomm-exhibitions-inner .slide-wrap');
            if (window.innerWidth < 768) {
                if(isSetCarousel_module === true){
                    $slide.vcCarousel('destroy');
                }
                isSetCarousel_module = false;
            } else{
                if(isSetCarousel_module === false){
                    $slide.vcCarousel({
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        speed: 150
                    });
                }
                isSetCarousel_module = true;
            }
        }).trigger('resize');
    }
    
    $(window).load(function(){
        init();

        // 기획전 스와이프
        // S : BTOCSITE-45005 2차 기획전 제작 모듈화(컴퍼넌트화) 우선 개발 요청
        var ww = $(window).outerWidth();
        function initSwiper() {
            ww = $(window).outerWidth();
            if(ww <= 767) {
                // mo
                $('.swiper-benefit-exclusive').each(function (idx, el) {
                    
                    if (el.swiper) {
                        el.swiper.update();
                        return;
                    }

                    new Swiper(el, {
                        slidesPerView: "auto",
                        pagination: {
                            el: el.querySelector('.swiper-pagination'),
                        },
                        on: {
                            beforeInit : function() {
                                var slides = this.el.querySelectorAll('.swiper-slide');
                                var parent = $(slides).closest ('.swiper-benefit-exclusive');
                                parent.removeClass('scr-center');
                                if (slides.length == 1) {
                                    parent.addClass('slide-solo');
                                }
                            }
                        },
                    });
                });
            } else {
                // pc
                $('.swiper-benefit-exclusive').each(function (idx, el) {
                    if (el.swiper) el.swiper.destroy(true, true);

                    if($(this).find('.swiper-slide').length > 4) {
                        $(this).removeClass('slide-solo').removeClass('scr-center');
                    } else  {
                        $(this).removeClass('slide-solo').addClass('scr-center');
                    }
                });
            }
        }

        initSwiper();

        // 기획전 유의사항
        function accEvt() {
            if(ww <= 767) {
                $('.btn-noti-acc').off('click').on('click', function (){
                    var parent = $(this).closest('.acc-wrap');
                    if(parent.hasClass('active')) {
                        parent.removeClass('active');
                        parent.find('.acc-cont').slideUp(100)
                    } else {
                        parent.addClass('active');
                        parent.find('.acc-cont').slideDown(100)
                    }
                });
            } else  {

            }
        }
        accEvt();
        
        // S : 내일배송 툴팁 활성
        $('.prd-tooltip-item .tag.tomorrow').click(function() {
            $(this).parents().parents().find('.tooltip-box').removeClass('active');
            $(this).next('.tooltip-box.tomorrow').addClass('active');
            $(this).closest('li').addClass('zIndex');
        });
        $('.prd-tooltip-item .tooltip-box.tomorrow .btn-close').click(function() {
            $(this).parents().removeClass('active');
            $(this).closest('li').removeClass('zIndex');
        });
        // E : 내일배송 툴팁 활성

        $(window).on('resize', function(){
            ww = $(window).outerWidth();
            initSwiper();
            accEvt();
        });
        
        // 엠블럼 노출
        setSubscriptionEmblemInfo();
    });

    $(document).on('ready',function(){
        //BTOCSITE-77414 > WA 전문가점검 > 8. 스크롤 제공되는 탭은 스크롤 액션이후 해당 위치로 초점이동
        $('.exhibition-tabs-wrap .ui_stickyTab, .tdpPrd-tabs-wrap .ui_stickyTab').on('stickyTabchange',function(e,obj){
            var id = obj.button.attr('href');
            setTimeout(function(){
                $(id).find('a').eq(0).focus();
            },300);
        });
        //쿠폰혜택 > 쿠폰 상세보기 팝업
        $('#coupon .text-box button').click(function(e) {
            e.preventDefault();

            var cpnPopup = $("#couponPopup");
            cpnPopup.children().remove();

            var ajaxUrl = $('.contents.event.exhibition').attr('data-coupon-info-ajax');
            var param = {};
            param.couponId = $(e.currentTarget).closest("li").attr("data-coupon-id");
            param.planEventType = $("#exhibitionDiv").data("plan-event-type");

            var cpnCnt;
            var couponList;

            lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                if (result.result === "S") {
                    cpnCnt = result.total;
                    couponList = result.data.couponList;

                    for (var i = 0; i < cpnCnt; i++) {
                        var item = couponList[i];

                        if (item.cpDiscPrice === 0) {
                            item._cpDiscVal = item.cpDiscRate;
                            item._cpDiscUnit = "%";
                        } else {
                            item._cpDiscVal = vcui.number.addComma(item.cpDiscPrice);
                            item._cpDiscUnit = "원";
                        }

                        if (item.cpPublEdDate) {
                            var edDate = item.cpPublEdDate.replace(/-/gi, "/");

                            item._cpPublEdDay = vcui.date.format(new Date(edDate), "yyyy년 M월 d일");
                            item._cpPublEdDate = vcui.date.format(new Date(edDate), "yyyy년 M월 d일 hh:mm");
                        } else {
                            item._cpPublEdDay = "";
                            item._cpPublEdDate = "";
                        }

                        if (item.cpPublStDate) {
                            var stDate = item.cpPublStDate.replace(/-/gi, "/");

                            item._cpPublStDate = vcui.date.format(new Date(stDate), "yyyy년 M월 d일 hh:mm");
                        } else {
                            item._cpPublStDate = "";
                        }

                        item._leftDayCnt = String(item.leftDayCnt);
                        item._cpDiscMinPrice = vcui.number.addComma(item.cpDiscMinPrice);
                        item._cpDiscMaxPrice = vcui.number.addComma(item.cpDiscMaxPrice);

                        cpnPopup.html(vcui.template(cpnInfoPopupTemplate, item).replace(/&lt;/gi, "<")
                            .replace(/&gt;/gi, ">").replace(/(?:\r\n|\r|\n)/g, '<br />'));

                    }
                }

                }.bind(this),
                true,
                true
            );
        });

        //BTOCSITE-65935 : 추천제품,타임딜 내일배송 팝업 클릭 이벤트 추가
        $('.btm-infobox .btn-delivery').click(function(e) {
            e.preventDefault();

            var deliveryPopup = $("#deliveryPopup");
            deliveryPopup.children().remove();

            var ajaxUrl = $('.contents.event.exhibition').attr('data-delivery-info-ajax');
            var param = {};
            param.modelId = $(e.currentTarget).closest("div").attr("data-model-id");

            lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                if (result.status == "S") {
                    deliveryPopup.html(vcui.template(deliveryPopupTemplate, {listCnt:result.dataCount, tomorrowDelivList:result.data}));
                }

                }.bind(this),
                true,
                true
            );
        });

    });

    // 엠블럼 노출 조회 (임직원/계열사/복지몰은 비노출)
    function setSubscriptionEmblemInfo() {
        var isEmblemDisplay = true;
        if (digitalData && digitalData.userInfo && digitalData.userInfo.partnerType) {
            if (digitalData.userInfo.partnerType == "AFF" || digitalData.userInfo.partnerType == "LGE" || digitalData.userInfo.partnerType == "AFC") {
                isEmblemDisplay = false;
            }
        }
        if (isEmblemDisplay) {
            $("div.middle-badge-list").find('span').show();
        }
    }

    // BTOCSITE-83952 쿠폰다운로드 여부 조회 ajax 분리
    function checkCouponDownload(){
        var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
        var planEventType = $contents.data("plan-event-type");
        var couponItems = $('#coupon .coupon-box');
        var couponIds = [];

        couponItems.each(function() {
            var couponId = $(this).data('coupon-id'); // Get the data-coupon-id using jQuery
            couponIds.push(couponId); // Add it to the array
        });

        var concatenatedCouponIds = couponIds.join(',');

        var ajaxUrl = $contents.data("coupon-download-check-ajax");
        var param = {};
        param.planEventType = planEventType;
        param.couponId = concatenatedCouponIds;

        if(isLogin == "Y"){
            lgkorUI.requestAjaxData(ajaxUrl, param, function (result) {
                if (result.status == "success") {
                    var data = result.data;

                    if(data.length > 0 && data != null){
                        for(var i in data){
                            var cpId = data[i].cpId;
                            var downloadYn = data[i].isDownload;

                            $("#coupon .evt-cont .coupon-list .coupon-box").each(function () {
                                if(cpId == $(this).attr("data-coupon-id") && "Y"==downloadYn){
                                    $(this).find(".cp-btn button").addClass("comp")
                                    $(this).find(".cp-btn button").css('cursor', 'default');
                                    $(this).find(".cp-btn button").css('pointer-events', 'none');
                                    $(this).find(".cp-btn button").css('color', '#'+$(this).find(".cp-btn button").parent().attr("data-btn-color"));
                                    $(this).find(".cp-btn button").text("");
                                    $(this).find(".cp-btn button").html("<span>발급<br>완료</span>");
                                    $(this).find(".cp-btn button").parent().parent().attr('style', '--cop-color:#666');
                                }
                            });
                        }
                        var couponCnt = $("#coupon .evt-cont .coupon-list .coupon-box").size();
                        var downCnt = $("#coupon .evt-cont .coupon-list .cp-btn .comp").size();

                        var $allDownBtn = $("#coupon .noti-cont .btn-area button");

                        if(parseInt(couponCnt) === parseInt(downCnt)){
                            $allDownBtn.text("");
                            $allDownBtn.text("전체 쿠폰 다운로드 완료");
                            $allDownBtn.attr("disabled", true);
                        }
                    }
                }
                $("#coupon .evt-cont .coupon-list .coupon-box").css('visibility', 'visible');
            },"GET", null, true);
        }else{
            $("#coupon .evt-cont .coupon-list .coupon-box").css('visibility', 'visible');
        }
    }

    function categoryProductList() {
        var modelIds = [];

        categoryProductListSelector.each(function() {
            var modelId = $(this).data('model-id');
            modelIds.push(modelId);
        });

        return modelIds;
    }

    function checkRecentlyViewdModel() {
        if (categoryProductList().length > 0) {
            var ajaxUrl = $contents.data("recently-viewd-model-list-ajax");
            var param = {};
            // BTOCSITE-88804 START
            lgkorUI.requestAjaxData(ajaxUrl, param, function (result) {
                if (result.status === "success") {
                    categoryProductListSelector.each(function () {
                        var modelId = $(this).data('model-id');
                        var data = result.data;
                        if (data != null && data.length > 0) {
                            for (var i in data) {
                                if (modelId === data[i]) {
                                    $("#viewdModel_" + modelId).show();
                                }
                            }
                        }
                    });
                }
            }, "GET", null, true);
            // BTOCSITE-88804 END
        }
    }

})();